<template>
    <div class="m-2">
        <div class="card m-2 shadow">

            <!--cabezera-->
            <div class="card-header">

                <div class="d-flex">
                    <div class="flex-fill">
                        <StatementsSearch></StatementsSearch>
                    </div>

                    <div class="float-end">
                        <StatementsPagination></StatementsPagination>
                    </div>

                </div>

            </div>

            <!--cuerpo-->
            <div class="card-body">
                <StatementsTable></StatementsTable>
            </div>
        </div>
    </div>
</template>
<script>
import StatementsTable from '@/components/FamilyStatements/FamilyStatementsList/Family-statements-table.vue'
import StatementsPagination from '@/components/FamilyStatements/FamilyStatementsList/Family-statements-pagination.vue';
import StatementsSearch from '@/components/FamilyStatements/FamilyStatementsList/Family-statements-search.vue';

export default {
    name: 'StatementsList',

    components:{
        StatementsTable,
        StatementsPagination,
        StatementsSearch
    }
}
</script>
<style></style>